// Module
var code = "<div class=\"l4-datascript-log\"> <div class=\"l4-datascript-log__header\"> {{ ::$ctrl.l10nKeys.datascriptHeader | vtranslate }} </div> <grid config=\"::$ctrl.gridConfig\" rows=\"::$ctrl.gridRows\"></grid> </div> ";
// Exports
export default code;